import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function LazyLoadingFallback({
  message = "One moment please...",
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexFlow: "column",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "rgba(255, 255, 255, 0.9)",
        position: "fixed",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1384,
      }}
    >
      <Box
        sx={{
          width: "96px",
          height: "96px",
          background: "#F6F6F6",
          borderRadius: "20px",
          border: "1px solid #D0D5DC",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          component="img"
          src="/img/inflxd-loading.gif"
          alt="loading..."
          sx={{ width: 64, height: 64, my: "56px", mx: "auto" }}
        />
      </Box>

      <Typography
        sx={{
          color: "#000",
          fontSize: "20px",
          fontWeight: "700",
          textAlign: "center",
          mt: "20px",
        }}
      >
        {message}
      </Typography>
    </Box>
  );
}
